import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "source"];

  prepare() {
    const selection = window.getSelection();
    const selectedText = selection?.toString()?.trim() || "";

    if (selectedText.length > 0 && this.selectionBelongsToContent(selection)) {
      this.sourceTarget.textContent = selectedText;
      return;
    }

    this.sourceTarget.textContent = this.contentTarget.innerText.trim();
  }

  copyAsPlainText(event) {
    const selection = window.getSelection();
    if (!selection || selection.isCollapsed) return;

    const selectedText = selection.toString();
    if (selectedText.trim().length === 0) return;

    event.preventDefault();
    event.clipboardData?.setData("text/plain", selectedText);
  }

  selectionBelongsToContent(selection) {
    if (!selection || selection.rangeCount === 0) return false;

    const range = selection.getRangeAt(0);
    const startNode = range.startContainer;
    const endNode = range.endContainer;

    return this.contentTarget.contains(startNode) && this.contentTarget.contains(endNode);
  }
}
